import { Box, Grid, IconButton, Paper, Theme, Tooltip, Typography, createStyles, makeStyles } from '@material-ui/core';

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			padding: theme.spacing(3, 2),
		},
	})
);

export default function DetailsError() {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<>
			<Paper className={classes.root}>
				<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
					<Tooltip title={t('common.back') || ''} onClick={() => window.history.back()}>
						<IconButton color='primary'>
							<ArrowBackIosIcon />
						</IconButton>
					</Tooltip>{' '}
					<Typography style={{ minWidth: '100px' }} variant='h6'>
						{t('common.back')}
					</Typography>
				</div>
				<Box mt={2}></Box>
				<Grid container>
					<Grid item xs={12} sm={7}>
						{t('errorCodes.NoData')}
					</Grid>
				</Grid>
			</Paper>
		</>
	);
}
